export default __webpack_public_path__ + "static/media/icon-spoton.34abe948.png";